export default "__VITE_ASSET__BTD8js1Q__"